/* Breathe with Little Bean (home hero). Choose 3, 5 or 10 breaths. 4 seconds in, 6 seconds out.
   Little Bean and the sun grow on the in-breath and settle on the out-breath. Dots show which breath you are on. */
(function () {
  function init(scene, t) {
    if (!scene || scene.dataset.lsBreathe) return;
    scene.dataset.lsBreathe = '1';
    var btn = scene.querySelector('[data-ls-breathe-btn]');
    var say = scene.querySelector('[data-ls-breathe-say]');
    if (!btn) return;
    var box = btn.parentNode;
    var label = btn.textContent;
    var howMany = 3, timers = [];

    var pick = document.createElement('div');
    pick.className = 'ls-breathe__pick'; pick.setAttribute('role', 'group'); pick.setAttribute('aria-label', 'How many breaths?');
    [3, 5, 10].forEach(function (n) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = n; b.dataset.n = n;
      b.setAttribute('aria-pressed', n === howMany ? 'true' : 'false');
      b.setAttribute('aria-label', n + ' breaths');
      b.addEventListener('click', function () {
        howMany = n;
        pick.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      });
      pick.appendChild(b);
    });
    var pickLabel = document.createElement('span'); pickLabel.className = 'ls-breathe__pick-label'; pickLabel.textContent = 'breaths';
    pick.appendChild(pickLabel);
    box.insertBefore(pick, say);

    var dots = document.createElement('div'); dots.className = 'ls-breathe__dots'; dots.setAttribute('aria-hidden', 'true'); dots.hidden = true;
    box.insertBefore(dots, say);

    function at(ms, fn) { timers.push(setTimeout(fn, ms)); }
    function stop() {
      timers.forEach(clearTimeout); timers = [];
      scene.classList.remove('is-in', 'is-out', 'is-breathing');
      btn.textContent = label; btn.setAttribute('aria-pressed', 'false');
      pick.hidden = false; dots.hidden = true;
    }
    function mark(i) {
      dots.querySelectorAll('span').forEach(function (d, n) { d.classList.toggle('is-done', n < i); d.classList.toggle('is-now', n === i); });
    }
    btn.addEventListener('click', function () {
      if (scene.classList.contains('is-breathing')) { stop(); say.textContent = ''; return; }
      scene.classList.add('is-breathing'); btn.textContent = t.stop; btn.setAttribute('aria-pressed', 'true');
      pick.hidden = true; dots.hidden = false; dots.innerHTML = '';
      for (var k = 0; k < howMany; k++) dots.appendChild(document.createElement('span'));
      var ms = 0;
      for (var i = 0; i < howMany; i++) {
        (function (i) {
          at(ms, function () { mark(i); scene.classList.remove('is-out'); scene.classList.add('is-in'); say.textContent = t.inn; });
          ms += 4000;
          at(ms, function () { scene.classList.remove('is-in'); scene.classList.add('is-out'); say.textContent = t.out; });
          ms += 6000;
        })(i);
      }
      at(ms, function () { mark(howMany); stop(); say.textContent = t.end; });
    });

    if (!document.getElementById('ls-breathe-css')) {
      var st = document.createElement('style'); st.id = 'ls-breathe-css';
      st.textContent =
        '.ls-breathe__pick{display:flex;align-items:center;gap:6px}' +
        '.ls-breathe__pick[hidden],.ls-breathe__dots[hidden]{display:none}' +
        '.ls-breathe__pick button{font:inherit;font-weight:600;font-size:13px;min-width:34px;height:30px;border:0;border-radius:20px;background:rgba(255,255,255,.7);color:#1F2A4D;cursor:pointer}' +
        '.ls-breathe__pick button[aria-pressed="true"]{background:#1F2A4D;color:#fff}' +
        '.ls-breathe__pick-label{font-size:13px;font-weight:500;color:#1F2A4D}' +
        '.ls-breathe__dots{display:flex;gap:7px;justify-content:center}' +
        '.ls-breathe__dots span{width:11px;height:11px;border-radius:50%;background:rgba(255,255,255,.75);box-shadow:inset 0 0 0 2px #1F2A4D;transition:background .4s,transform .4s}' +
        '.ls-breathe__dots span.is-now{background:#FFC93C;transform:scale(1.25)}' +
        '.ls-breathe__dots span.is-done{background:#1F2A4D}';
      document.head.appendChild(st);
    }
  }
  window.LSBreathe = init;
})();
